import styled from 'styled-components';

const LimitHeight = styled.div`
  max-height: calc(100vh - ${(p) => p.margin});
  overflow-y: auto;
`;

export default LimitHeight;
